import Util from "@/helper/Utility.js";
import Account from '@/helper/AccountHelper.js';

export default {
    inject: ["AccountStore"],
    computed: {
        isInitial: function () {
            return this.AccountStore.state.isInitial;
        },
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        isLoginGuest: function () {
            if (this.isInitial) {
                let account = Account.getCacheUser();
                if (account.loginChanel) 
                    return account?.loginChanel == 'device';
                else  
                    return account?.channel == 'device';
            }
            return true;
        },
        isLoginAccount: function () {
            return !this.isLoginGuest;
        },
        isGuestAccountRegistered: function () {
            if (this.isLoginGuest) {
                let contactNumber = this.profile?.contactNumber;
                return Util.isEmptyStr(contactNumber) ? false : true;
            }
            return false;
        },
        profile: function () {
            if (this.isLogin) {
                return this.AccountStore.state.profile;
            } else {
                return null;
            }
        },
        userPoint: function () {
            if (this.isLogin) {
                return this.AccountStore.state.point;
            } else {
                return 0;
            }
        },
        userFirstname: function () {
            return this.profile?.firstName ?? '';
        },
    },
    created: function () {
        this.AccountStore.methods.loginStatus().subscribe(() => {
            if (Util.isFunction(this.onAccountInit)) {
                // Util.log('profile', this.profile);
                this.onAccountInit();
            }
        });
    },
    methods: {
        setUpdatePoint: function (point) {
            this.AccountStore.methods.setUpdatePoint(point);
        },
        setUpdateProfile: function (profile) {
            this.AccountStore.methods.setProfile(profile);
        },
        setInitial: function () {
            this.AccountStore.methods.init();
        },
        apiUpdateProfile: function () {
            return this.AccountStore.methods.setupProfile();
        },
    },
}
